export default "__VITE_ASSET__CtkPk07d__"